export const getHttpError = ( responseError ) => {
  if (!responseError || !responseError.response) return { common: 'Неизвестная ошибка' };
  const { response: { data, status } } = responseError;
  if (status === 403) return { common: 'Недостаточно прав' };
  if (typeof data === 'string') return { common: responseError };
  if (typeof data !== 'object' || !data) return { common: 'Неизвестная ошибка' };
  if (!data) return responseError;
  if (typeof data === 'string') return { common: data };
  if (data.errors) return data.errors;
  if (data.message) return { common: data.message };
  if (data.error) return data.error;
  if (typeof data === 'object' && data !== null) return data;
  return { common: data.toString() };
};
// export default extractHttpError;

// export const getHttpError = (responseError: HttpError): Record<string, string> => {
//   try {
//     extractHttpError(responseError);
//   } catch (error) {
//     return error;
//   }
// }
